import React from 'react';

import LocaleMessage from '~/components/LocaleMessage';

export default function CleaningTaskTableHead() {
    return (
        <thead>
            <tr>
                <th>
                    <LocaleMessage msg="page.robots.cleaning_report.live.col_robot" />
                </th>
                <th>
                    <LocaleMessage msg="page.robots.cleaning_report.col_task" />
                </th>
                <th>
                    <LocaleMessage msg="page.robots.cleaning_report.col_clean_time" />
                </th>
                <th>
                    <LocaleMessage msg="page.robots.cleaning_report.metrics.efficiency" />
                </th>
                <th>
                    <LocaleMessage msg="page.robots.cleaning_report.col_area" />
                </th>
                <th>
                    <LocaleMessage msg="page.robots.cleaning_report.col_created" />
                </th>
                <th>
                    <LocaleMessage msg="page.robots.cleaning_report.col_mode" />
                </th>
                <th>
                    <LocaleMessage msg="page.robots.cleaning_report.col_status" />
                </th>
            </tr>
        </thead>
    );
}
